import { render, staticRenderFns } from "./app-download.vue?vue&type=template&id=0b2affac&scoped=true&"
import script from "./app-download.vue?vue&type=script&lang=js&"
export * from "./app-download.vue?vue&type=script&lang=js&"
import style0 from "./app-download.vue?vue&type=style&index=0&id=0b2affac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2affac",
  null
  
)

export default component.exports